import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { FlashMessagesService } from '../flash-messages/service/flash.messages.service';


@Injectable()
export class PermissionGuard implements CanActivate {


  constructor(private authStore: AuthenticationStore,
              private flashMessagesService: FlashMessagesService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.data && route.data[ 'allowedPermissions' ]) {
      return this.authStore.hasPermission(route.data[ 'allowedPermissions' ] as Array<string>);
    } else {
      this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE',
        `The route [${route.toString()}] was not given data specifying allowed permissions`);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/guards/permission-guard.ts